'use es6';

import { isNil } from '../../js-util';
import { getProblem } from './get-problem';
export function isEnabled(params, getAllProblems) {
  const problem = getProblem(params, getAllProblems);
  return isNil(problem);
}